import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { TeamScheduleResponse, fetchTeamSchedule } from '../api/teamSchedule.api';

interface TeamScheduleState {
  schedule: TeamScheduleResponse[];
  startDate: Date;
  endDate: Date;
  status: Record<number, 'loading' | 'succeeded' | 'failed'>;
  error: string | null;
}

const initialState: TeamScheduleState = {
  schedule: [],
  startDate: new Date(),
  endDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
  status: {},
  error: null,
};

export const fetchTeamScheduleAsync = createAsyncThunk(
  'teamSchedule/fetch',
  async ({ teamId, startDate, endDate }: { teamId: number, startDate: Date, endDate: Date }) => {
    return await fetchTeamSchedule(teamId, startDate, endDate);
  }
);


export const teamScheduleSlice = createSlice({
  name: 'teamSchedule',
  initialState,
  reducers: {
    setStartDate: (state, action: PayloadAction<Date>) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action: PayloadAction<Date>) => {
      state.endDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamScheduleAsync.pending, (state, action) => {
        state.status[action.meta.arg.teamId] = 'loading';
      })
      .addCase(fetchTeamScheduleAsync.fulfilled, (state, action) => {
        state.status[action.meta.arg.teamId] = 'succeeded';
        state.schedule[action.meta.arg.teamId] = action.payload;
      })
      .addCase(fetchTeamScheduleAsync.rejected, (state, action) => {
        state.status[action.meta.arg.teamId] = 'failed';
        state.error = action.payload as string;
      });
  },
});

export const { setStartDate, setEndDate } = teamScheduleSlice.actions;

export const selectedStartDate = (state: RootState) => state.teamSchedule.startDate;
export const selectedEndDate = (state: RootState) => state.teamSchedule.endDate;

export default teamScheduleSlice.reducer;
